export const noAnimation = '0ms cubic-bezier(0, 0, 0, 0)';
export const accordionAnimation = '400ms cubic-bezier(0.86, 0, 0.07, 1)';
